import React from 'react';
import { CONTRACT_TYPE } from "../../../../../util/varibles/constants";
import { IContract, IVessel } from "../../../../../util/varibles/interface";
import Contract from "./Contract";

interface IProps {
    contracts: IContract[]
    vessel: IVessel
    vesselIndex: number
    width: number
}

const Contracts: React.FC<IProps> = (props) => {
    const { vesselIndex, width, contracts, vessel } = props;

    return <>
        {contracts.map((item) => item.type === CONTRACT_TYPE.FIXED && <Contract
            key={item.id}
            vesselIndex={vesselIndex}
            width={width}
            contract={item}
            vessel={vessel}
        />, [])}
    </>
};

export default Contracts;
